import { render, staticRenderFns } from "./LoginPromptModal.vue?vue&type=template&id=ac5490e6"
import script from "./LoginPromptModal.vue?vue&type=script&lang=js"
export * from "./LoginPromptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports